{
  "title": "Retours & Remboursements",
  "request_title": "Demande de retour",
  "my_returns": "Mes retours",
  "no_returns": "Aucun retour",
  "no_returns_description": "Vous n'avez effectué aucune demande de retour.",
  "policy": {
    "title": "Politique de retour",
    "window": "Vous disposez de {{days}} jours après la livraison pour effectuer un retour.",
    "deadline": "Date limite de retour : {{date}}",
    "photos_required": "Des photos sont requises pour cette demande.",
    "auto_approve_notice": "Les retours de moins de {{amount}} FCFA sont approuvés automatiquement."
  },
  "reasons": {
    "DEFECTIVE": "Produit défectueux",
    "WRONG_ITEM": "Mauvais article reçu",
    "NOT_AS_DESCRIBED": "Non conforme à la description",
    "CHANGED_MIND": "Changement d'avis",
    "EXPIRED": "Produit expiré",
    "OTHER": "Autre"
  },
  "status": {
    "REQUESTED": "Demandé",
    "APPROVED": "Approuvé",
    "PICKUP_SCHEDULED": "Enlèvement prévu",
    "RECEIVED": "Reçu",
    "REFUND_PROCESSING": "Remboursement en cours",
    "REFUND_COMPLETED": "Remboursé",
    "REJECTED": "Refusé"
  },
  "refund_methods": {
    "ORIGINAL_PAYMENT": "Moyen de paiement d'origine",
    "WAVE": "Wave",
    "ORANGE_MONEY": "Orange Money",
    "STORE_CREDIT": "Crédit boutique"
  },
  "form": {
    "step_items": "Sélectionner les articles",
    "step_reason": "Motif du retour",
    "step_details": "Détails & photos",
    "step_review": "Vérification",
    "select_items": "Sélectionnez les articles à retourner",
    "quantity": "Quantité",
    "reason_label": "Motif du retour",
    "reason_placeholder": "Sélectionnez un motif",
    "description_label": "Description du problème",
    "description_placeholder": "Décrivez le problème rencontré avec votre commande…",
    "photos_label": "Photos (optionnel)",
    "photos_hint": "Ajoutez des photos pour faciliter le traitement de votre demande.",
    "review_order": "Commande",
    "review_items": "Articles à retourner",
    "review_reason": "Motif",
    "review_description": "Description",
    "review_refund_estimate": "Remboursement estimé",
    "submit": "Soumettre la demande",
    "submitting": "Envoi en cours…",
    "cancel": "Annuler",
    "next": "Suivant",
    "previous": "Précédent",
    "success_title": "Demande soumise avec succès",
    "success_message": "Votre demande de retour a bien été enregistrée. Notre équipe l'examinera dans les 48 heures.",
    "success_ref": "Réf. retour : {{id}}",
    "error_no_items": "Veuillez sélectionner au moins un article.",
    "error_no_reason": "Veuillez sélectionner un motif.",
    "error_no_description": "Veuillez décrire le problème rencontré.",
    "error_generic": "Une erreur est survenue. Veuillez réessayer."
  },
  "card": {
    "order_ref": "Commande {{ref}}",
    "created_on": "Demandé le {{date}}",
    "resolved_on": "Résolu le {{date}}",
    "refund_amount": "Montant du remboursement",
    "refund_method": "Mode de remboursement",
    "rejection_reason": "Motif du refus",
    "items_count": "{{count}} article",
    "items_count_plural": "{{count}} articles",
    "tracking": "Suivi"
  },
  "filter": {
    "all": "Tous",
    "active": "En cours",
    "completed": "Terminés"
  },
  "loading": "Chargement des retours…",
  "error_loading": "Impossible de charger vos retours."
}
